import { Avatar, ListItem, ListItemIcon, ListItemText } from 'components/ui';
import { dashboardCompanyOverviewUrl } from 'dashboard409a/common/config/urls';
import SelectionPinButton from 'pages/Auth/components/SelectionPinButton';
import { getInitials } from 'utilities';
import type { CompanyProps } from './Company.props';
import { companyClasses, StyledLink } from './Company.styles';

const Company = ({ slug, name, id, isPinnable = false, isPinned = false, updatePinStatus }: CompanyProps) => (
  <ListItem
    secondaryAction={
      isPinnable ? (
        <SelectionPinButton id={id} isPinned={isPinned} onToggle={updatePinStatus} title={name} />
      ) : undefined
    }
  >
    <StyledLink to={dashboardCompanyOverviewUrl(slug)}>
      <ListItemIcon>
        <Avatar className={companyClasses.avatar}>{getInitials({ name })}</Avatar>
      </ListItemIcon>
      <ListItemText primary={name} />
    </StyledLink>
  </ListItem>
);

export default Company;
